module.exports = __webpack_public_path__ + "site/img/114.151dd0ca.jpg";